type PError = {
  data?: string;
  name?: string;
  retcode?: string;
  retmsg?: string;
};

/**
 * 将promise执行结果格式化成[error, data]
 * @param promise promise实例
 */
export async function to<P extends Promise<any> = Promise<any>>(promise: P) {
  try {
    const data = await promise;
    return [null, data] as [null, P extends Promise<infer R> ? R : any];
  } catch (err) {
    return [err, null] as [PError, null];
  }
}

/**
 * 获取promise实例及句柄
 */
export function getPromiseHandler<T = any>() {
  let resolve; let reject;
  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return {
    resolve: resolve as (value: T | PromiseLike<T>) => void,
    reject: reject as (reason?: any) => void,
    promise,
  };
}
